import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { PROVIDER_LABELS, type Provider, type Result } from "./renderCheckTypes";

type Props = {
  editing: { template_key: string; provider: Provider } | null;
  editResult: Result | "";
  editNotes: string;
  saving: boolean;
  onResultChange: (r: Result | "") => void;
  onNotesChange: (n: string) => void;
  onCancel: () => void;
  onSave: () => void;
};

export const RenderCheckEditDialog = ({
  editing,
  editResult,
  editNotes,
  saving,
  onResultChange,
  onNotesChange,
  onCancel,
  onSave,
}: Props) => (
  <Dialog open={editing !== null} onOpenChange={(open) => !open && onCancel()}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>
          {editing && `${editing.template_key} · ${PROVIDER_LABELS[editing.provider]}`}
        </DialogTitle>
      </DialogHeader>
      <div className="space-y-4">
        <div className="space-y-2">
          <Label>Result</Label>
          <div className="flex gap-2">
            {(["pass", "issue", "fail"] as Result[]).map((r) => (
              <Button
                key={r}
                type="button"
                variant={editResult === r ? "default" : "outline"}
                size="sm"
                onClick={() => onResultChange(r)}
              >
                {r}
              </Button>
            ))}
            <Button
              type="button"
              variant={editResult === "" ? "default" : "outline"}
              size="sm"
              onClick={() => onResultChange("")}
            >
              clear
            </Button>
          </div>
        </div>
        <div className="space-y-2">
          <Label htmlFor="notes">Notes</Label>
          <Textarea
            id="notes"
            value={editNotes}
            onChange={(e) => onNotesChange(e.target.value)}
            placeholder="Anything off about the rendering, layout, dark mode, links, etc."
          />
        </div>
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={onCancel} disabled={saving}>
          Cancel
        </Button>
        <Button onClick={onSave} disabled={saving}>
          {saving && <Loader2 className="h-4 w-4 animate-spin" />}
          Save
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
